import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'prototypes/securedCard/app.module.scss';
import AppChrome from 'prototypes/securedCard/components/AppChrome';
import { formatMoney } from 'prototypes/securedCard/formatMoney';
import { PrototypePath } from 'prototypes/securedCard/paths';
import { useStory } from 'prototypes/securedCard/StoryContext';
import { LedgerFilter, LedgerKind } from 'prototypes/securedCard/types';

const matchesFilter = (kind: LedgerKind, filter: LedgerFilter): boolean => {
  if (filter === LedgerFilter.All) {
    return true;
  }
  if (filter === LedgerFilter.Rewards) {
    return kind === LedgerKind.Cashback;
  }
  return kind !== LedgerKind.Cashback;
};

const TransactionsStep = () => {
  const navigate = useNavigate();
  const { ledger } = useStory();
  const [filter, setFilter] = useState(LedgerFilter.All);
  const visible = ledger.filter((entry) => matchesFilter(entry.kind, filter));

  return (
    <AppChrome
      step={PrototypePath.Transactions}
      title="Activity"
      subtitle="Paychecks in, the grocery run paid from savings, interest, and cashback."
    >
      <div className={styles.stack}>
        <div className={styles.filters}>
          {Object.values(LedgerFilter).map((item) => (
            <button
              key={item}
              type="button"
              className={filter === item ? `${styles.filter} ${styles.filterOn}` : styles.filter}
              aria-pressed={filter === item}
              onClick={() => setFilter(item)}
            >
              {item}
            </button>
          ))}
        </div>
        <div className={styles.ledger}>
          {visible.map((entry) => (
            <div key={entry.id} className={styles.ledgerRow}>
              <div>
                <p className={styles.ledgerTitle}>{entry.title}</p>
                <p className={styles.ledgerDetail}>{entry.detail}</p>
                <p className={styles.ledgerMeta}>
                  {entry.dateLabel} · {entry.affectsSavings ? 'Savings' : 'Earnings'}
                </p>
              </div>
              <p className={entry.amountCents < 0 ? styles.amountOut : styles.amountIn}>
                {formatMoney(entry.amountCents)}
              </p>
            </div>
          ))}
          {visible.length === 0 && <p className={styles.notice}>Nothing in this filter yet.</p>}
        </div>
        <button type="button" className={styles.quietButton} onClick={() => navigate(PrototypePath.Dashboard)}>
          Back to the card
        </button>
      </div>
    </AppChrome>
  );
};

export default TransactionsStep;
